export default __webpack_public_path__ + "d7f8f3c3ba44cb5ca6f14293e614de5e.svg";